import script from "./OPay.vue?vue&type=script&setup=true&lang=ts"
export * from "./OPay.vue?vue&type=script&setup=true&lang=ts"

import "./OPay.vue?vue&type=style&index=0&id=760de09c&lang=css"

const __exports__ = script;

export default __exports__